<template>
  <div class="eksSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="clusterName"
          :placeholder="$t('RAM.common.QuerybyClusterName')"
        />
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="['resourceConfigurationManagement:aws:eks:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil";
import TableElasticKubernetesService from "../eks/TableElasticKubernetesService";
var tableElasticKubernetesService = TableElasticKubernetesService;
export default {
  name: "ElasticKubernetesServiceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      clusterName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableElasticKubernetesService.methods.showAll();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("clusterName", this.clusterName);
      tableElasticKubernetesService.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
      });
    }
  }
};
</script>
<style scoped>
.eksSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/eks/ElasticKubernetesServiceSearch.vue